import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import DemoAwareButton from 'bv360/components/demo/button';

export default class DeleteModal extends React.PureComponent {
  render() {
    const { isLastAdmin, otherUsers, selectedReplacementId, onSelectReplacement } = this.props;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Please Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Are you sure you want to delete this user?</h5>
          {isLastAdmin && (
            <div style={{ marginTop: '1rem' }}>
              <p>
                <strong>This user is the only practice administrator.</strong> Please select a
                replacement administrator from the candidate list below, or select No Replacement
                to skip and leave the practice without an administrator for now.
              </p>
              <Form>
                <strong>Candidate Administrators</strong>
                <div style={{ marginTop: '0.5rem' }}>
                  {(otherUsers || []).length === 0 ? (
                    <span className="text-muted">None</span>
                  ) : (
                    (otherUsers || []).map(u => (
                      <Form.Check
                        key={u.id}
                        type="radio"
                        id={`replacement-${u.id}`}
                        name="replacement"
                        label={`${u.user.first_name} ${u.user.last_name} (${u.user.username})`}
                        checked={selectedReplacementId === u.id}
                        onChange={() => onSelectReplacement(u.id)}
                      />
                    ))
                  )}
                </div>
                <hr />
                <Form.Check
                  type="radio"
                  id="replacement-none"
                  name="replacement"
                  label="No Replacement — leave practice without an administrator"
                  checked={selectedReplacementId === null}
                  onChange={() => onSelectReplacement(null)}
                />
              </Form>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={evt => this.props.onHide(null)}
            variant="secondary"
            className="btn--fw"
          >
            Cancel
          </Button>
          <DemoAwareButton
            demoAlert="This would delete a user"
            type="button"
            onClick={this.props.deleteHandler}
          >
            {isLastAdmin ? 'Confirm Admin Delete' : 'Delete'}
          </DemoAwareButton>
        </Modal.Footer>
      </Modal>
    );
  }
}
